export default "__VITE_ASSET__Dlm5i3ET__"